import { render } from "./FormSinesterPersons.vue?vue&type=template&id=2844d406"
import script from "./FormSinesterPersons.vue?vue&type=script&lang=js"
export * from "./FormSinesterPersons.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__